import React, { useState } from "react";
import PropTypes from "prop-types";

import { useApolloClient, useQuery } from "react-apollo";

import { Input } from "rbx";

import gql from "graphql-tag";
import Downshift from "downshift";
import { DropDown, DropDownItem, SearchStyles } from "../../styles/DropDown";

import { debounce } from "../../utils";

const SEARCH_CUSTOMERS_QUERY = gql`
  query SEARCH_CUSTOMERS_QUERY($where: CustomerWhereInput = {}) {
    Customers(where: $where, first: 10) {
      RecId
      CustomerNo
      Name
      City
      State
    }
  }
`;

const SINGLE_CUSTOMER_QUERY = gql`
  query SINGLE_CUSTOMER_QUERY($where: CustomerWhereUniqueInput!) {
    Customer(where: $where) {
      RecId
      CustomerNo
      Name
      City
      State
    }
  }
`;
const CustomerSearch = ({ onChange, customerRecId, disabled }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);

  const { data } = useQuery(SINGLE_CUSTOMER_QUERY, {
    variables: { where: { RecId: customerRecId || null } }
  });

  const client = useApolloClient();

  const getInputValue = customer =>
    customer ? `${customer?.CustomerNo} - ${customer?.Name}` : "";

  const handleChange = debounce(async e => {
    setLoading(true);
    const res = await client.query({
      query: SEARCH_CUSTOMERS_QUERY,
      variables: {
        where: {
          OR: [
            { CustomerNo_startsWith: e.target.value.trim(), OrderCust: true },
            { Name_startsWith: e.target.value.trim(), OrderCust: true }
          ]
        }
      }
    });
    setCustomers(res.data.Customers);
    setLoading(false);
  }, 350);

  return (
    <SearchStyles>
      {(!customerRecId || data?.Customer) && (
        <Downshift
          initialInputValue={getInputValue(data?.Customer)}
          itemToString={customer =>
            customer === null ? "" : `${customer.CustomerNo} - ${customer.Name}`
          }
          onChange={customer =>
            onChange({
              target: { name: "CustomerRecIdRef", value: customer.RecId }
            })
          }
        >
          {({
            getInputProps,
            getItemProps,
            isOpen,
            inputValue,
            highlightedIndex
          }) => (
            <div>
              <Input
                autocomplete="new"
                disabled={disabled}
                state={loading ? "loading" : ""}
                type="search"
                {...getInputProps({
                  type: "search",
                  placeholder: "Customer #",
                  id: "search",
                  onChange: e => {
                    e.persist();
                    handleChange(e);
                  }
                })}
              />
              {isOpen && (
                <DropDown>
                  {customers.map((customer, i) => (
                    <DropDownItem
                      highlighted={i === highlightedIndex}
                      key={i}
                      {...getItemProps({ item: customer })}
                    >
                      <div className="customer-no">{customer.CustomerNo}</div>
                      <div className="customer-name">{customer.Name}</div>
                      <div className="customer-location">
                        {customer.City &&
                          customer.State &&
                          `${customer.City}, ${customer.State}`}
                      </div>
                    </DropDownItem>
                  ))}
                  {!customers.length && !loading && (
                    <DropDownItem>Nothing found for {inputValue}.</DropDownItem>
                  )}
                </DropDown>
              )}
            </div>
          )}
        </Downshift>
      )}
    </SearchStyles>
  );
};

// CustomerSearch is really picky about getting customer rec id before initial render

CustomerSearch.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  customerRecId: PropTypes.number.isRequired
};

export default CustomerSearch;
